import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION14: PdfComponent = {
  type: 'section',
  id: 'iars14',
  title: '14. Governing Law and Jurisdiction',
  content: [
    {
      type: 'altText',
      id: 'iars14bullets',
      content: [
        'This Agreement shall be governed by and construed in accordance with ',
        'English law',
        ', and both parties submit to the ',
        'exclusive jurisdiction of the courts of England and Wales',
        '.',
      ],
      boldFirst: false,
    },
  ],
};
